import { BrandCard as BrandCardFuse } from "@tvg/fuse-design/brand-card";
import { ImageLink } from "amp-types/tabs-schema";
import getImageLink from "client/utils/getImageLink";
import getImageSources from "client/utils/getImageSources";
import React, { useMemo } from "react";
import { AmpBrandCard } from "types/amplience";
import { Brand } from "types/common";

export interface BrandCardProps {
  slide: AmpBrandCard;
  brand: Brand;
  lazyLoad?: boolean;
  highPriority?: boolean;
}

export const BrandCard: React.FC<BrandCardProps> = ({
  slide: { backgroundImage, hideLabel, label, link, logoImage },
  brand,
  lazyLoad,
  highPriority,
}) => {
  const cardProps = useMemo(
    () => ({
      ariaLabel: hideLabel ? label : undefined,
      backgroundImage: backgroundImage && {
        alt: "",
        isLazy: lazyLoad,
        fetchPriority: highPriority ? "high" : undefined,
        imageSrc: getImageLink(backgroundImage as ImageLink, { brand, w: 740, qlt: "default" }),
        ...getImageSources(backgroundImage, {
          brand,
          templates: ["poi"],
          aspect: "3:4",
          w: 740, // Confirm image width for optimisation
          qlt: "default",
        }),
      },
      label: hideLabel ? "" : label,
      link,
      logoImage: logoImage && {
        alt: "",
        isLazy: lazyLoad,
        fetchPriority: highPriority ? "high" : undefined,
        imageSrc: getImageLink(logoImage as ImageLink, { brand, w: 740, qlt: "default" }),
        ...getImageSources(logoImage, {
          brand,
          w: 740, // Confirm image width for optimisation
          qlt: "default",
        }),
      },
    }),
    [brand, backgroundImage, hideLabel, label, link, logoImage, lazyLoad, highPriority],
  );
  return <BrandCardFuse {...cardProps} dataTestId="content-brand-card" />;
};
